import { render, staticRenderFns } from "./TodoAvatar.vue?vue&type=template&id=07977d91&scoped=true"
import script from "./TodoAvatar.vue?vue&type=script&lang=ts"
export * from "./TodoAvatar.vue?vue&type=script&lang=ts"
import style0 from "./TodoAvatar.vue?vue&type=style&index=0&id=07977d91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07977d91",
  null
  
)

export default component.exports